function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var DashboardTemplate = require('./dashboard.template');
var _require = require('../peer-node-info'),
  buildPeerNodeInfo = _require.buildPeerNodeInfo;
var _require2 = require('../explorer-format'),
  formatSaito = _require2.formatSaito;
var _require3 = require('../module-detect'),
  summarizeModulePopularity = _require3.summarizeModulePopularity;
var MODULE_LIST_LIMIT = 6;
var Dashboard = /*#__PURE__*/function () {
  function Dashboard(app, mod) {
    _classCallCheck(this, Dashboard);
    this.app = app;
    this.mod = mod;
    this.container = null;
    this.fetchToken = 0;
    this.peerNode = {
      ready: false,
      loading: true,
      error: null
    };
  }
  return _createClass(Dashboard, [{
    key: "render",
    value: function render(container) {
      if (!container) {
        return;
      }
      this.container = container;
      this.paint();
      this.loadPeerNodeInfo();
    }
  }, {
    key: "paint",
    value: function paint() {
      if (!this.container) {
        return;
      }
      this.app.browser.replaceElementContentBySelector(DashboardTemplate({
        peerNode: this.peerNode,
        blockchain: this.buildBlockchainInfo(),
        modules: this.buildModulePopularity(),
        app: this.app
      }), this.container);
    }
  }, {
    key: "buildBlockchainInfo",
    value: function buildBlockchainInfo() {
      var info = this.mod.chainInfo;
      var ready = this.mod.chainInfoReady;
      var error = this.mod.chainInfoError;
      if (!info) {
        if (error) {
          return {
            loading: false,
            ready: false,
            error: error,
            rows: []
          };
        }
        return {
          loading: !ready,
          ready: false,
          error: null,
          rows: []
        };
      }
      var integer = function integer(value) {
        return value == null ? '—' : Number(value).toLocaleString('en-US');
      };
      var saito = function saito(value) {
        return value == null ? '—' : formatSaito(value);
      };

      // The ATR (Automatic Transaction Rebroadcast) frontier block is the oldest
      // block still retained in the current epoch — i.e. the blockchain's
      // genesis_block_id — whose unspent slips are rebroadcast as it falls out of
      // the genesis window.
      var rows = [{
        label: 'Burn Fee',
        value: saito(info.burnfee)
      }, {
        label: 'Difficulty',
        value: integer(info.difficulty)
      }, {
        label: 'ATR Block',
        value: integer(info.genesis_block_id)
      }, {
        label: 'Golden Ticket Coverage',
        value: this.formatGoldenTicketCoverage(info)
      }];
      return {
        loading: false,
        ready: true,
        error: null,
        rows: rows
      };
    }
  }, {
    key: "formatGoldenTicketCoverage",
    value: function formatGoldenTicketCoverage(info) {
      var _info$golden_ticket_w, _info$golden_ticket_c;
      var window = Number((_info$golden_ticket_w = info === null || info === void 0 ? void 0 : info.golden_ticket_window) !== null && _info$golden_ticket_w !== void 0 ? _info$golden_ticket_w : 0);
      var count = Number((_info$golden_ticket_c = info === null || info === void 0 ? void 0 : info.golden_ticket_count) !== null && _info$golden_ticket_c !== void 0 ? _info$golden_ticket_c : 0);
      if (!Number.isFinite(window) || window <= 0) {
        return '—';
      }
      var percent = Math.round(count / window * 100);
      return "".concat(percent, "% (").concat(count, "/").concat(window, ")");
    }
  }, {
    key: "buildModulePopularity",
    value: function buildModulePopularity() {
      var ready = this.mod.transactionsReady;
      var error = this.mod.transactionsError;
      if (!ready) {
        return {
          loading: true,
          ready: false,
          error: null,
          rows: [],
          total: 0
        };
      }
      var _summarizeModulePopul = summarizeModulePopularity(this.mod.transactions || [], {
          limit: MODULE_LIST_LIMIT
        }),
        rows = _summarizeModulePopul.rows,
        total = _summarizeModulePopul.total;
      return {
        loading: false,
        ready: true,
        error: error || null,
        rows: rows,
        total: total
      };
    }
  }, {
    key: "loadPeerNodeInfo",
    value: function () {
      var _loadPeerNodeInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$mod$explorerPee;
        var token, info, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              token = ++this.fetchToken;
              if ((_this$mod$explorerPee = this.mod.explorerPeer) !== null && _this$mod$explorerPee !== void 0 && _this$mod$explorerPee.publicKey) {
                _context.n = 1;
                break;
              }
              this.peerNode = {
                ready: false,
                loading: false,
                error: null
              };
              this.paint();
              return _context.a(2);
            case 1:
              this.peerNode = {
                ready: false,
                loading: true,
                error: null
              };
              this.paint();
              _context.p = 2;
              _context.n = 3;
              return buildPeerNodeInfo(this.app, this.mod);
            case 3:
              info = _context.v;
              if (!(token !== this.fetchToken)) {
                _context.n = 4;
                break;
              }
              return _context.a(2);
            case 4:
              this.peerNode = info;
              _context.n = 7;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              if (!(token !== this.fetchToken)) {
                _context.n = 6;
                break;
              }
              return _context.a(2);
            case 6:
              console.error('Explorer: failed to load peer node info', _t);
              this.peerNode = {
                ready: false,
                loading: false,
                error: 'Unable to load node information.'
              };
            case 7:
              this.paint();
            case 8:
              return _context.a(2);
          }
        }, _callee, this, [[2, 5]]);
      }));
      function loadPeerNodeInfo() {
        return _loadPeerNodeInfo.apply(this, arguments);
      }
      return loadPeerNodeInfo;
    }()
  }]);
}();
module.exports = Dashboard;